'use strict';

var base = require('base/product/base');
var focusHelper = require('base/components/focus');
var debounce = require('lodash/debounce');
var debounceQuantity = debounce(updateQuantity, 200);
var debounceUndo = debounce(ajaxDeleteUndo, 500);

function updateQuantity(scope) {
    var $parent = $(scope).parent();
    var preSelectQty;
    if($(scope).hasClass('quantity-mobile')){
        preSelectQty = $(scope).val();
    } else {
        preSelectQty = $(scope).data('pre-select-qty');
    }
    var quantity = parseInt(preSelectQty);
    var productID = $(scope).data('pid');
    var url = $(scope).data('action');
    var uuid = $(scope).data('uuid');

    var urlParams = {
        pid: productID,
        quantity: quantity,
        uuid: uuid
    };
    url = appendToUrl(url, urlParams);

    $(scope).parents('.card').spinner().start();

    $('body').trigger('cart:beforeUpdate');

    $.ajax({
        url: url,
        type: 'get',
        context: scope,
        dataType: 'json',
        success: function (data) {
            for (var i = 0; i < data.items.length; i++) {
                var lineItem = data.items[i];
                if (lineItem && lineItem.UUID == uuid) {
                    var min = lineItem.quantityOptions.minOrderQuantity;
                    var max = lineItem.quantityOptions.maxOrderQuantity;
                    var newQuantity = lineItem.quantity;
                    var cardItem = $(this).closest('.card.product-info');
                    //$("#" +lineItem.UUID).remove();

                    if (lineItem.quantity > min) {
                        $parent.find('.quantity-selector__btn.decrease').data('pre-select-qty', parseInt(lineItem.quantity, 10) - 1);
                        $parent.find('.quantity-selector__btn.decrease').removeClass('disabled');
                        $parent.find('.quantity-selector__btn.increase').prop('disabled', false);
                    } else {
                        $parent.find('.quantity-selector__btn.decrease').addClass('disabled');
                    }
                    if (lineItem.quantity < max) {
                        $parent.find('.quantity-selector__btn.increase').data('pre-select-qty', parseInt(lineItem.quantity, 10) + 1);
                        $parent.find('.quantity-selector__btn.increase').removeClass('disabled');
                        $parent.find('.quantity-selector__btn.increase').prop('disabled', false);
                    } else {
                        $parent.find('.quantity-selector__btn.increase').addClass('disabled');
                    }
                    if((lineItem.availability.notAvailable || !lineItem.isOrderable) && cardItem) {
                        cardItem.addClass('error-highlighting');
                    } else {
                        cardItem.removeClass('error-highlighting');
                        cardItem.find('.product-card-footer .custom-isml-message').html('');
                    }

                    var selectMobileOptions = $parent.find('select.quantity-mobile option');
                    if (selectMobileOptions) {
                        for (var j = 0; j < selectMobileOptions.length; j++) {
                            if(selectMobileOptions[j] && selectMobileOptions[j].dataset['value'] > max ) {
                                selectMobileOptions[j].disabled = true
                            }
                        }
                    }
                }
            }
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
            //$('.quantity[data-uuid="' + uuid + '"]').val(parseInt(newQuantityMobile));
            $parent.find('.quantity-selector__number').html(parseInt(newQuantity, 10));
            $parent.parents('div.product-info').find('button.remove-product').data('qty', newQuantity);

            updateCartTotals(data);
            updateApproachingDiscounts(data.approachingDiscounts);
            updateAvailability(data, uuid);
            validateBasket(data);

            $('body').trigger('cart:update', data);

            $.spinner().stop();
            if ($(scope).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                location.reload();
            }
            $(scope).closest('div.line-item-quantity').siblings('div.delete-button').find('button.remove-product').data('qty', newQuantity);

            // remove bundle item if all quantity isn't available 
            if((data.removedProducts && data.removedProducts.length) || data.updatedQuantity){
                data.removedProducts.forEach(removedProduct => {
                    $(`.uuid-${removedProduct.UUID}`).remove();
                });
                // mark as red product unavailable
                data.unavailableProducts.forEach(product => {
                    $(`.uuid-${product.UUID}`).addClass('error-highlighting');
                })
                toastr.error(data.updateQuantityMessage);
            }

            // remove bundle item if OOS
            if(data.listBundleOutOfStock){
                // mark as red product unavailable
                data.listBundleOutOfStock.forEach(product => {
                    $(`.uuid-${product.UUID}`).addClass('error-highlighting');
                })
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                var unavailableMessage = $(this).data('messageItemUnavailable') || "Item Unavailable";
                var unavailableMessageDescription = $(this).data('itemUnavailableDescription') || "This item is currently not available";
                var mobileSelect = $(this).hasClass('quantity-mobile');
                var desktopButton = $(this).hasClass('quantity-selector__btn');
                if(mobileSelect) {
                    $(this).prop('disabled', 'disabled');
                }
                if(desktopButton) {
                    $(this).prop('disabled', 'disabled');
                    $(this).addClass('disabled');
                }
                createErrorNotification(err.responseJSON.errorMessage);
                $(scope).val(parseInt(preSelectQty, 10));
                $.spinner().stop();
                $(this).closest('.card.product-info .product-card-footer').find('.custom-isml-message').remove();
                $(this).closest('.card.product-info').addClass('error-highlighting');
                $(this).closest('.card.product-info .product-card-footer').append(`
                    <div class="custom-isml-message mt-6 d-flex align-items-center line-item-error-cart mr-10 mb-5 mb-md-0 flex-wrap flex-md-nowrap">
                        <div class="product-error mr-6">${unavailableMessage}</div>
                        <div class="product-error-message">${unavailableMessageDescription}</div>
                    </div>
                `);
            }
        }
    });
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.errorInfo && data.valid.message) {
        toastr.error(data.valid.message);
    }
    if (data.valid.error) {
        if (data.valid.message) {
            toastr.error(data.valid.message);
            // var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
            //     'fade show" role="alert">' +
            //     '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
            //     '<span aria-hidden="true">&times;</span>' +
            //     '</button>' + data.valid.message + '</div>';

            // $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.js-total-item').empty().append(data.numItems > 1 ? data.resources.numberOfItems : data.resources.numberOfItem );
    $('.shipping-cost .shipping-cost-value').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.merchandize-total-price del').empty().append(data.totals.saveTotal != '' ? data.totals.merchandizeTotalPrice : '');
    $('.save-total').empty().append(data.totals.saveTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart .minicart-quantity').attr('data-quantity', data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append(data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    toastr.error(message);
    // var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
    //     'fade show" role="alert">' +
    //     '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
    //     '<span aria-hidden="true">&times;</span>' +
    //     '</button>' + message + '</div>';

    // $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    var benefitHtml = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        if ($('.benefit-bar-approaching-discounts').is(':empty')) {
            $('.benefit-bar-approaching-discounts').slideUp().empty();
        }
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center text-dark">' +
            '<div class="progress">' +
                    `<progress class="progress-bar bg-dark" role="progressbar" max="100" value="${item.merchandisePercentOf.toFixed(0)}"></progress>`
            +'</div>' + item.discountMsg + '</div>';
            if (item.benefitBarMsg) {
                benefitHtml = item.benefitBarMsg;
            }
        });
    } else {
        $('.benefit-bar-approaching-discounts').slideUp().empty();
    }
    $('.approaching-discounts').append(html);
    if ($('.benefit-bar-approaching-discounts').is(':empty')) {
        $('.benefit-bar-approaching-discounts').append(benefitHtml).slideDown();
    }
    initProgressBar();
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';
    var lowStockIcons = $('.product-card-footer [name=lowStockIcons-'+uuid+']').val();

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('#' + lineItem.UUID).empty();
        /* if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }
            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        } */
        if(lineItem.leadTime != "" && lineItem.leadTime != null) {
            messages += `
                <div class="d-flex align-items-center mr-10 mb-5 mb-md-0">
                    <i class="material-icons mr-4">local_shipping</i>
                    <span>${lineItem.leadTime}</span>
                </div>
            `;
        }
        if(lineItem.availability.showlowStockMessage) {
            messages += `
                <div class="d-flex align-items-center mr-10 mb-5 mb-md-0">
                    <img class="mr-4" width="24" height="24" src="${lowStockIcons}" alt="" />
                    <span>${lineItem.availability.showlowStockMessage}</span>
                </div>
            `;
        }
        $('#' + lineItem.UUID).html(messages);
    } 

    if(data.valid.error == false) {
        $('.card.product-info.uuid-' + lineItem.UUID).removeClass('error-highlighting')
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    //$productToRemoveSpan.empty().append(productName);
}

function initProgressBar() {
    var $progressBar = $('.progress .progress-bar');
    if ($progressBar.length && $progressBar.data('percent')) {
        $progressBar.animate({width: $progressBar.data('percent')});
    }
}

function ajaxDeleteUndo(scope) {
    var $this = $(scope);
    var productID = $this.data('pid');
    var url = $this.data('action');
    var qty = $this.data('qty');
    var urlParams = {
        pid: productID,
        quantity: qty
    };

    $('body > .modal-backdrop').remove();

    $.spinner().start();

    $('body').trigger('cart:beforeUpdate');

    $.ajax({
        url: url,
        type: 'post',
        data: urlParams,
        dataType: 'json',
        success: function (data) {
            if (data.cart.items.length === 0) {
                $('.cart').empty().append('<div class="row"> ' +
                    '<div class="col-12 text-center"> ' +
                    '<h1>' + data.cart.resources.emptyCartMsg + '</h1> ' +
                    '</div> ' +
                    '</div>'
                );
                $('.number-of-items').empty().append(data.cart.resources.numberOfItems);
                $('.minicart-quantity').empty().append(data.cart.numItems);
                $('.minicart-link').attr({
                    'aria-label': data.cart.resources.minicartCountOfItems,
                    title: data.cart.resources.minicartCountOfItems
                });
                $('.minicart .popover').empty();
                $('.minicart .popover').removeClass('show');
                $('body').removeClass('modal-open');
                $('html').removeClass('veiled');
            } else {
                location.reload();
            }
            $('body').trigger('cart:update', data);

            $.spinner().stop();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
                $.spinner().stop();
            }
        }
    });
}


/**
 * replace content of alert
 * @param {string} pid - product id
 * @param {string} pname - product name
 * @param {number} deletedQuantity - deletedQuantity
 */
function showAlertUndo(pid, pname, deletedQuantity) {
    $('button.cart-delete-undo-btn').data('qty', deletedQuantity);

    var actionUrl = $('.data_product_undo').data('actionUrl');
    var labelUndo = $('.data_product_undo').data('labelUndo');
    var labelItemsRemoved = $('.data_product_undo').data('labelItemremoved');

    const toastAlertUndo = `
    <div id="${pid}" class="d-flex justify-content-start align-items-center mx-auto">
        <div class="mr-6 d-flex align-items-center flex-fill">
            <div class="product-to-remove">${labelItemsRemoved}</div>
        </div>
        <button
            type="button"
            class="cart-delete-undo-btn cta-link"
            data-action="${actionUrl}"
            data-pid="${pid}"
            data-qty="${deletedQuantity}">
            ${labelUndo}
        </button>
    </div>`;

    if(toastAlertUndo) {
        toastr.success(toastAlertUndo);
    }

    $(document).on("click", ".cart-delete-undo-btn", function() {
        debounceUndo(this);
    });

}

module.exports = function () {

    $(document).ready(function () {
        var $element = $('.fixed-total-order');
        var $elementPosition = $('.cart-totals .checkout-continue .checkout-btn').length && $('.cart-totals .checkout-continue .checkout-btn').offset().top;
        $(window).scroll(function () {
            var $scrollViewport = $(window).scrollTop() + $(window).innerHeight();
            if($scrollViewport >= $elementPosition + $element.height() ) {
                $element.removeClass('fixed');
            } else {
                $element.addClass('fixed');
            }
        })

        if($('.page').data('action') == 'Cart-Show'){
            var path = window.location.pathname;
            var page = path.split('/').pop();
            //remove querystring
            // page = page.split('?')[0];

            history.replaceState(null, null, page);
        }
    });

    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        var unavailable = $(this).data('unavailable');
        if (!unavailable) {
            confirmDelete(actionUrl, productID, productName, uuid);
        }
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        //toastr.clear();
        showAlertUndo(data.productID, data.productName, data.deletedQuantity);
    });

    /* $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    }); */

    $('body').on('click', 'button.remove-product', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var productName = $(this).data('name');
        var deletedQuantity = $(this).data('qty');
        var unavailable = $(this).data('unavailable');
        var iconEmptyCart = $(this).data('srcEmptycart');

        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                
                    var htmlEmptyCartTemplate = `
                    <div class="container cart-empty">
                        <div class="row">
                            <div class="col-12 text-center">
                                <div class="icon-cart-title">
                                    <img width="20" height="20" src="${iconEmptyCart}" alt="" />
                                </div>
                                <h1 class="text-uppercase">${data.basket.resources.emptyCartMsg}</h1>
                                <div class="d-flex justify-content-center mt-6 mt-lg-8 mb-10">
                                    <a href="${data.basket.backToShoppingAbsUrl}" class="cta cta-ghost cta-40" type="">
                                        <i class="ml-0 material-icons notranslate">arrow_back</i>
                                        ${data.basket.resources.backToShopping}
                                    </a>
                                </div>
                                <p class="need-some-help">
                                    ${data.basket.resources.needHelpText}
                                </p>
                            </div>
                        </div>
                    </div>
                    `;
                    
                    $('.cart-page-title').empty();
                    $('.cart').empty().append(htmlEmptyCartTemplate);
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.minicart .minicart-quantity').attr('data-quantity', data.basket.numItems);
                    $('.minicart .minicart-quantity').text('');
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart-link').append('<span class="tooltip bottom-tooltip d-none">'+data.basket.resources.emptyCartTooltipMsg+'</span>');
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                $('body').trigger('cart:update', data);
                if (!unavailable) {
                    $('body').trigger('afterRemoveFromCart', {
                        productID: productID,
                        productName: productName,
                        deletedQuantity: deletedQuantity
                    });
                }
                for (var i = 0; i < data.basket.items.length; i++) {
                    var lineItem = data.basket.items[i];
                    if (lineItem) {
                        var cardItem = $('.card.product-info.uuid-' + lineItem.UUID);
    
                        if(cardItem && (lineItem.availability.notAvailable || !lineItem.isOrderable)) {
                            cardItem.addClass('error-highlighting');
                        } else {
                            cardItem.removeClass('error-highlighting');
                            cardItem.find('.product-card-footer .custom-isml-message').html('');
                            updateAvailability(data.basket, lineItem.UUID);
                        }
                    }
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity);

                $('body').trigger('cart:update', data);

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('.coupon-error-message').show();
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                    // remove bundle item if all quantity isn't available
                    if(data.removedProducts && data.removedProducts.length){
                        data.removedProducts.forEach(removedProduct => {
                            $(`.uuid-${removedProduct.UUID}`).remove();
                        });
                        toastr.error(data.updateQuantityMessage);
                    }

                    if(data.unavailableProducts && data.unavailableProducts.length){
                        // mark as red product unavailable
                        data.unavailableProducts.forEach(product => {
                            $(`.uuid-${product.UUID}`).addClass('error-highlighting');
                        })
                    }

                    // remove bundle item if OOS
                    if(data.listBundleOutOfStock && data.listBundleOutOfStock.length){
                        // mark as red product unavailable
                        data.listBundleOutOfStock.forEach(product => {
                            $(`.uuid-${product.UUID}`).addClass('error-highlighting');
                        })
                    }
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        //$('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                $('.coupon-message-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
                // remove bundle item if all quantity isn't available
                if(data.removedProducts && data.removedProducts.length){
                    data.removedProducts.forEach(removedProduct => {
                        $(`.uuid-${removedProduct.UUID}`).remove();
                    });
                    toastr.error(data.updateQuantityMessage);
                }

                if(data.unavailableProducts && data.unavailableProducts.length){
                    // mark as red product unavailable
                    data.unavailableProducts.forEach(product => {
                        $(`.uuid-${product.UUID}`).addClass('error-highlighting');
                    })
                }
                
                // remove bundle item if OOS
                if(data.listBundleOutOfStock && data.listBundleOutOfStock.length){
                    // mark as red product unavailable
                    data.listBundleOutOfStock.forEach(product => {
                        $(`.uuid-${product.UUID}`).addClass('error-highlighting');
                    })
                }
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr('disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });
    initProgressBar();

    $('#alert-cart-undo .cart-dismiss-alert').on('click', function () {
        $("#alert-cart-undo").addClass('d-none').fadeOut(500);
    })

    $('body').on('click', '.quantity-form .quantity-selector__btn:not(.disabled)', function () {
        debounceQuantity(this);
    });

    $('body').on('change', '.quantity-form .quantity-mobile', function () {
        debounceQuantity(this);
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
